export const TARGET_URL_QUERY_PARAM = 'target';
export const RESET_PASSWORD_TOKEN_QUERY_PARAM = 'token';
